module.exports = __webpack_public_path__ + "static/img/work-banner.53f1085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/work-banner.jpg
// module id = aPVk
// module chunks = 5